import { createVoucher, getReferees, getBanner } from '~/api/referral';

export const state = () => ({
  refereeList: [],
  banner: [],
});

export const getters = {
  getRefereeList: state => state.refereeList || [],
  getBanner: state => state.banner || [],
};

export const mutations = {
  setRefereeList(state, data) {
    state.refereeList = data;
  },
  setBanner(state, data) {
    state.banner = data;
  },
};

export const actions = {
  async createVoucher({ commit }) {
    try {
      this.dispatch('flashalert/hideFlashAlert');
      const response = await createVoucher(this.$axios);
      if (response.meta.http_status === 201) commit('setVoucher', response.data.code);
      return response;
    } catch (error) {
      const message = 'Gagal mendapatkan kode referral.';
      this.dispatch('flashalert/showFlashAlert', {
        message,
        type: 'warning',
        autoHide: true,
      });
      // eslint-disable-next-line no-console
      console.error(message, error);
    }
  },
  async getReferees({ commit }, status) {
    try {
      const response = await getReferees(this.$axios, status);
      if (response.meta.http_status === 200) commit('setRefereeList', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
  async getBanner({ commit }) {
    try {
      const response = await getBanner(this.$axios);
      if (response.meta.http_status === 200) commit('setBanner', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
};
